// extracted by mini-css-extract-plugin
module.exports = {"integral_rule_wrap":"rule_integral_rule_wrap__262d6"};